import React, { Component } from 'react';
import { Tag } from 'primereact/tag';

import { RelatedEntityGrid as EntityGrid } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelTextArea } from 'hay-core-react';
import { ModelInputNumber } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import { Usuario } from 'hay-core-react';

import PesquisaResposta   from '../../../models/PesquisaResposta';
import PesquisaEnvio      from '../../../models/PesquisaEnvio';
import Pesquisa           from '../../../models/Pesquisa';
import PesquisaTipoEnum   from '../../../enums/PesquisaTipoEnum';
import PesquisaRespostaClassificacaoNpsEnum from '../../../enums/PesquisaRespostaClassificacaoNpsEnum';

// ─── Mapeamento classificacaonps → Tag (mesmo padrão de UsuarioTransacaoTemplate.js) ──────────

const CLASSIFICACAO_CONFIG = {
    'main.pesquisaresposta.classificacaonps.detrator': { severity: 'danger', icon: 'pi-thumbs-down' },
    'main.pesquisaresposta.classificacaonps.neutro':   { severity: 'warning', icon: 'pi-minus-circle' },
    'main.pesquisaresposta.classificacaonps.promotor': { severity: 'success', icon: 'pi-thumbs-up' },
};

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    pesquisaenvio: {
        exibir:       'main.pesquisaresposta.pesquisaenvio',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'token',
        entidade:     'pesquisaenvio.entidade',
        template:     'pesquisaenvio.template',
    },
    pesquisa: {
        exibir:       'main.pesquisaresposta.pesquisa',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'nome',
        entidade:     'pesquisa.entidade',
        template:     'pesquisa.template',
    },
    usuario: {
        exibir:       'main.pesquisaresposta.usuario',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'nome',
        entidade:     'usuario.entidade',
        template:     'usuario.template',
    },
    // Reusa o mesmo enum de Pesquisa.tipo - snapshot desse mesmo campo/namespace no momento da
    // resposta (ver comentario em PesquisaResposta.js no backend).
    tipo: {
        exibir:   'main.pesquisaresposta.tipo',
        visivel:  true,
        tipo:     'enum',
        entidade: 'pesquisa.tipo',
        largura: "7rem",
    },
    nota: { exibir: 'main.pesquisaresposta.nota', visivel: true, tipo: 'numeric', largura: '6rem' },
    classificacaonps: {
        exibir:   'main.pesquisaresposta.classificacaonps',
        visivel:  true,
        tipo:     'enum',
        entidade: 'pesquisaresposta.classificacaonps',
        template: 'classificacaonps.template',
    },
    comentario: { exibir: 'main.pesquisaresposta.comentario', visivel: true },
    createdAt: { exibir: 'main.createdAt', visivel: true, tipo: 'date', time: true },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const renderers = {
    pesquisaenvio: { entidade: PesquisaEnvio, template: (rowData) => rowData.pesquisaenvio?.token || rowData.pesquisaenvio?.id || '' },
    pesquisa:      { entidade: Pesquisa, template: (rowData) => rowData.pesquisa?.nome || rowData.pesquisa?.id || '' },
    usuario:       { entidade: Usuario, template: (rowData) => rowData.usuario?.nome || rowData.usuario?.id || '' },
    'pesquisa.tipo':                       PesquisaTipoEnum,
    'pesquisaresposta.classificacaonps':   PesquisaRespostaClassificacaoNpsEnum,
    classificacaonps: {
        template: (rowData) => {
            if (!rowData.classificacaonps) return null;
            const cfg = CLASSIFICACAO_CONFIG[rowData.classificacaonps] || { severity: 'info', icon: 'pi-circle' };
            return (
                <Tag
                    severity={cfg.severity}
                    icon={`pi ${cfg.icon}`}
                    value={UtilService.traduzir(rowData.classificacaonps)}
                    className="white-space-nowrap"
                />
            );
        },
    },
};

// ─── Formulário (só "Ver" - resposta enviada pelo usuário via link público) ───

class PesquisaRespostaFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        return (
            <div className="grid">
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={{ ...model.pesquisaenvio, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={{ ...model.pesquisa, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={{ ...model.usuario, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={{ ...model.tipo, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelInputNumber model={{ ...model.nota, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={{ ...model.classificacaonps, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 mt-3">
                    <ModelTextArea model={{ ...model.comentario, disabled: true }} contexto={contexto} rows={4} />
                </div>
            </div>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class PesquisaRespostaTemplate extends Component {
    render() {
        return (
            <EntityGrid
                entidade={PesquisaResposta}
                model={model}
                identidade="main.pesquisaresposta"
                permissoes={this.props.permissoes}
                icone="pi-star"
                storageKey="dt-pesquisarespostas"
                relacionados={[]}
                renderers={renderers}
                configuracao={this.props.configuracao}
                ordenacaoPadrao={{ sortField: 'createdAt', sortOrder: -1 }}
                formulario={(m, ctx) => <PesquisaRespostaFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default PesquisaRespostaTemplate;
